import React from 'react';
import { withRouter } from 'react-router-dom';

import store from 'root/admin';

import { useGetRecords } from 'root/admin/components/hooks';
import { Title, CreateNew } from 'root/admin/components';

import { Loader, Table, Column } from '@smartplatform/ui';

const ListInformation = ({ match, rootPath, tabName }) => {
	const { id } = match.params;
	const options = { where: { awardId: id } };
	const records = useGetRecords({ model: 'AwardInformation', options, tabName });

	if (!records) {
		return <Loader />;
	}

	console.log(records);
	return (
		<div>
			<Title records={records} name="Информация о награде" />
			<CreateNew link={`${rootPath}/${id}/awardinformations/new`} name="Добавить информацию" />

			<Table records={records} rootPath={`${rootPath}/${id}`}>
				<Column property="name" label="Заголовок" />
			</Table>
		</div>
	);
};

// @observer
// class EditInformation extends React.Component {
// 	@observable record;

// 	async componentDidMount() {
// 		const { id } = this.props.match.params;
// 		this.record = store.model.AwardInformation.find({where: {awardId: id}});
// 	}

// 	render () {
// 		if (!this.record) {
// 			return <Loader />
// 		}

// 			return (
// 		<div>
// 			<Title records={records} name="Информация о награде" />
// 			<CreateNew link={`${rootPath}/${id}/awardinformations/new`} name="Добавить информацию" />

// 			<Table records={records} rootPath={`${rootPath}/${id}`}>
// 				<Column property="name" label="Заголовок" />
// 			</Table>
// 		</div>
// 	);
// 	}

// }

export default withRouter(ListInformation);
